/* eslint-disable no-undef */
(function () {
  angular.module('MktzapApp.Factories')
    .factory('CompanyEmployerService', CompanyEmployerService)

  CompanyEmployerService.$inject = ['$resource']

  function CompanyEmployerService ($resource) {
    return $resource(apiUrl + '/channels-plugin/company-employer/:id', { id: '@id' }, {
      all: { method: 'GET', params: {}, isArray: true },
      create: { method: 'POST', params: {}, isArray: false },
      update: { method: 'PATCH', params: {}, isArray: false },
      findOne: { method: 'GET', params: {}, isArray: false },
      delete: { method: 'DELETE', params: {}, isArray: false },
      deleteEmployer: { url: apiUrl + '/channels-plugin/company-employer/delete-employer', method: 'POST', isArray: false }
    })
  }
// eslint-disable-next-line semi
})();
